import { render, staticRenderFns } from "./ImprestSurrenderDocument.vue?vue&type=template&id=64fea840"
import script from "./ImprestSurrenderDocument.vue?vue&type=script&lang=js"
export * from "./ImprestSurrenderDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports